import React from 'react'
import Select from 'react-select'
import i18n from '../../../translations/i18n'

function SelectTeamMember(props) {
  const { t } = i18n
  const handleSelectChange = (option) => {
    if (!!option) {
      props.setSelectedTeamMembers([option.value])
    } else {
      props.setSelectedTeamMembers([])
    }
  }

  console.log(props.selectedTeamMembers)

  return (
    <div style={{ maxHeight: '60vh', padding: 20 }}>
      <p style={{ marginBottom: 20 }}>{t('select-one-of-team-members')}</p>

      <Select
        className="basic-single"
        classNamePrefix="select"
        isSearchable
        options={props.teamMembers}
        onChange={handleSelectChange}
        value={props.teamMembers.find(
          (s) => s.value === props.selectedTeamMembers[0]
        )}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
      />
    </div>
  )
}

export default SelectTeamMember
